'use strict';

angular.module('mobile-apps').controller('LanguagesController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$location',
	'Authentication',
	'Languages',
	'AvailableLanguages',
	'MobileApps',
	'MobileAppLanguageMau',
	'MobileAppLanguagesStatistics',
	'EntryCount',
	'SweetAlert',
	'EntryMain',
	'$timeout',
	'$aside',
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$location,
		Authentication,
		Languages,
		AvailableLanguages,
		MobileApps,
		MobileAppLanguageMau,
		MobileAppLanguagesStatistics,
		EntryCount,
		SweetAlert,
		EntryMain,
		$timeout,
		$aside
	) {
		$scope.authentication = Authentication;
		$scope.mau = 0;
		$scope.languageEntryCountMap = {};
		$scope.availableLanguagesToAdd = [];
		$scope.recommenedLanguages = [];
		$scope.availableLanguages = [];
		$scope.availableLanguageOrder = {
			reverse: false,
			property: 'ISO'
		};
		$scope.createForm = {
			name                  : '',
			languageNameToCopyFrom: null,
			shouldBeCopied        : true
		};
		$scope.breadcrumbs = {
			mobileAppId: $stateParams.mobileAppId,
			languageId : $stateParams.languageId
		};
		$scope.mobileAppAllLanguagesStatistics = [];

		$scope.setAvailableLanguageSorting = function(propertyName) {
			if (propertyName === $scope.availableLanguageOrder.property) {
				$scope.availableLanguageOrder.reverse = !$scope.availableLanguageOrder.reverse;
			} else {
				$scope.availableLanguageOrder = {
					reverse: false,
					property: propertyName
				};
			}
		};

		$scope.toggleHistory = function(){
			//console.log("toggleHistory");
			var asideInstance = $aside.open({
				templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
				controller: 'ChangelogController',
				placement: 'left',
				size: 'lg',
				resolve: {
					loadData: undefined
				}
			});
		};
		/**
		 * Init call all available lang and most popular
		 * and add callback to call get all added languages
		 */
		$scope.initListView = function () {
			$scope.mobileAppId = $stateParams.mobileAppId;
			async.parallel({
				availableLanguages: $scope.fetchAvailableLanguages,
				inAppLanguages: $scope.fetchInAppLanguages,
				mobileAppAllLanguagesStatistics: $scope.fetchMobileAppAllLanguagesStatistics,
				mobileApp : $scope.fetchMobileApp
			}, function (err, results) {
				if (err) {
					return;
				}

				var mostPopularList = [
					'Chinese (Simplified)',
					'English',
					'Spanish (Mexico)',
					'Arabic',
					'Russian',
					'Portuguese (Brazil)',
					'German',
					'French',
					'Japanese'
				];

				$scope.mobileAppAllLanguagesStatistics.forEach(function (language) {

					// Push available languages in list
					$scope.availableLanguagesToAdd.push(language);

					// Push most popular languages in list
					if (_.includes(mostPopularList, language.name)) {
						$scope.recommenedLanguages.push(language);
					}
				});

				$scope.availableLanguages = results.availableLanguages;
				$scope.languages = results.inAppLanguages;
				$scope.mobileApp = results.mobileApp;
				$scope.collectAppLanguageStats();
				$scope.updateExistingLanguagesStatus();
				$scope.loadedStatus = true;
			});
		};

		$scope.fetchMobileApp = function (callback) {
			MobileApps.get({
				mobileAppId: $stateParams.mobileAppId
			}, function (response) {
				return callback(null, response);
			}, function (errResponse) {
				return callback(errResponse);
			});
		};

		$scope.fetchMobileAppLanguageMau = function (callback) {
			MobileAppLanguageMau.get({
				mobileAppId: $stateParams.mobileAppId,
				languageId : $stateParams.languageId
			}, function (response) {
				return callback(null, response);
			}, function (errResponse) {
				return callback(errResponse);
			});
		};

		/**
		 * Calculate some values that describes language more deeply.
		 *
		 * @param language
		 */

		function addLanguageStatus (entryLanguage, language) {
			if (entryLanguage.name === language.ISO) {
				language.exists = true;
			}
		}

		function checkLanguageStatus (language) {
			$scope.recommenedLanguages.forEach(function(recommenedLanguage) {
				addLanguageStatus(language, recommenedLanguage);
			});
			$scope.availableLanguagesToAdd.forEach(function(availableLanguage) {
				addLanguageStatus(language, availableLanguage);
			});
		}

		// Create new Language
		$scope.create = function (languageData) {
			var language =  new Languages({name : languageData.ISO});
			language.$save({
				mobileAppId: $stateParams.mobileAppId
			}, function (response) {
				$scope.languages.push({
					_id   : response._id,
					name  : response.name
				});

				// Force refresh of the cached app Data (with languages)
				EntryMain.loadMobileApp($stateParams.mobileAppId, true, function() {});

				$scope.collectLanguageStats(language);
				checkLanguageStatus(response);

			}, function (errorResponse) {
				$scope.error = errorResponse.data.message;
				$scope.validationErrors = errorResponse.data.validationErrors;
			});
			$rootScope.$broadcast('intercom_event',{
				eventName :'created-language',
				data : {
					language : language.name,
					appId : $stateParams.mobileAppId
				}
			});

		};


		$scope.openDeleteLanguageModal = function (language) {

			var languageToDelete = _.find($scope.languages, {name: language.ISO});

			$timeout(function() {
				SweetAlert.swal(
					{
						title: 'Are you sure?',
						text: 'This will delete the Language "' + language.name + '" with all its Translations and can not be recovered.',
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText: 'Yes, delete it!',
						cancelButtonText: 'No, cancel!',
						closeOnConfirm: false,
						closeOnCancel: true
					},
					function (isConfirm) {
						if (isConfirm) {
							$scope.removeLanguage(languageToDelete, function (err) {
								if (err) {

									$timeout(function() {
										SweetAlert.swal(
											{
												title: 'Oops!',
												text: err.data.message,
												type: 'error',
												showCancelButton: false
											}
										);
									}, 50);
									return;
								}

								$timeout(function() {
									SweetAlert.swal(
										{
											title: 'Deleted!',
											text: 'Language has been deleted.',
											type: 'success',
											showCancelButton: false
										}, function (isConfirmed) {
											if (isConfirmed) {
												$location.path('projects/' + $stateParams.mobileAppId);
											}
										}
									);
								}, 50);
							});
						}
					}
				);
			}, 50);
		};


		// Remove existing Language
		$scope.removeLanguage = function (language, cb) {
			Languages.remove({
				mobileAppId: $stateParams.mobileAppId,
				languageId: language._id
			}, function (result) {
				if (angular.isFunction(cb)) {
					cb();
				}

				// Remove the deleted language
				for (var i=0;i<$scope.languages.length;i++) {
					if ($scope.languages[i]._id === language._id) {
						$scope.languages.splice(i, 1);
						break;
					}
				}

				// Force refresh of the cached app Data (with languages)
				EntryMain.loadMobileApp($stateParams.mobileAppId, true, function() {});

				$scope.updateExistingLanguagesStatus();
			}, function (err) {
				if (angular.isFunction(cb)) {
					cb(err);
				}
			});
		};


		$scope.getLanguageIcon = function (string, nb) {
			if (string) {
				var result = string;

				/*if(string.indexOf('-') > -1)
				 {

				 }*/
				var array = string.split('-');

				if (array.length > (nb)) {
					result = array[nb].toLowerCase();
				}
				else {
					result = 'empty';
				}

				if (result.length === 0) {
					result = 'empty';
				}

				if (result === 'en') {
					result = 'gb';
				}
				return 'modules/mobile-apps/img/flags/flags_iso/16/' + result + '.png';
			}

		};


		// Update existing Language
		$scope.update = function () {
			var language = $scope.language;

			if (language.shouldBeCopied !== true) {
				language.languageNameToCopyFrom = 'undefined';
			}

			language.$update({
				mobileAppId: $stateParams.mobileAppId
			}, function () {

				// Force refresh of the cached app Data (with languages)
				EntryMain.loadMobileApp($stateParams.mobileAppId, true, function() {});

				$location.path('projects/' + $stateParams.mobileAppId + '/languages/' + language._id);
			}, function (errorResponse) {
				$scope.error = errorResponse.data.message;
				$scope.validationErrors = errorResponse.data.validationErrors;
			});
		};

		// Find a list of Available Languages
		$scope.fetchAvailableLanguages = function (callback) {

			AvailableLanguages.get(function success (response) {
				callback(null, response);
			}, function failure(errorResponse) {
				callback(errorResponse);
			});

		};

		$scope.fetchInAppLanguages = function (callback) {
			Languages.query(
				{
					mobileAppId: $stateParams.mobileAppId
				},
				function success (response) {
					callback(null, response);
				}, function failure (errResponse) {
					callback(errResponse);
				});
		};

		$scope.fetchMobileAppAllLanguagesStatistics = function(callback) {
			MobileAppLanguagesStatistics.get({
				mobileAppId: $stateParams.mobileAppId
			}, function(response) {
				$scope.mobileAppAllLanguagesStatistics = response;

				return callback();
			}, function(errResponse) {
				return callback(errResponse);
			});
		};

		// Get all added Languages in app
		$scope.collectAppLanguageStats = function () {

			_.forEach($scope.languages, function (language) {
				$scope.collectLanguageStats(language);
			});

		};

		$scope.collectLanguageStats = function (language) {
			EntryCount.getCountforLanguages(
				{languageId : language._id,
					mobileAppId : $stateParams.mobileAppId
				}, function(languageCounts)
				{
					languageCounts.status = {
						green : (languageCounts.notTranslated === 0)?true: false,
						red   : (languageCounts.notTranslated>0)?true:false,
						orange: (languageCounts.draft>0)?true:false
					};
					$scope.languageEntryCountMap[language._id] = languageCounts;
				});
		};

		$scope.updateExistingLanguagesStatus = function ()
		{
			$scope.recommenedLanguages.forEach(function(recommenedLanguage) {
				recommenedLanguage.exists = false;
			});
			$scope.availableLanguagesToAdd.forEach(function(availableLanguage) {
				availableLanguage.exists = false;
			});
			_.forEach($scope.languages, function (language) {
				checkLanguageStatus(language);
			});
		};

		$scope.changeEntry = function (languageId) {
			$scope.loadedStatus = false;
			$state.go('viewLanguage', {
				mobileAppId: $scope.mobileAppId,
				languageId : languageId
			});
		};

		$scope.navigateToLanguageEntries = function($event, languageId) {
			if ($event.metaKey || $event.shiftKey || $event.ctrlKey || 
				$event.which === 2 || $event.button === 2) {
				$event.preventDefault();
				var url = $state.href('viewLanguage.entry', {
					mobileAppId: $scope.mobileAppId,
					languageId: languageId
				}, { absolute: true });
				window.open(url, '_blank');
			} else {
				$state.go('viewLanguage.entry', {
					mobileAppId: $scope.mobileAppId,
					languageId: languageId
				});
			}
		};

		$scope.navigateToState = function ($event, languageId, stateName) {
			if ($event.metaKey || $event.shiftKey || $event.ctrlKey || 
				$event.which === 2 || $event.button === 2) {
				$event.preventDefault();
				var url = $state.href('viewLanguage.entry.state', {
					mobileAppId: $scope.mobileAppId,
					languageId: languageId,
					stateName: stateName
				}, { absolute: true });
				window.open(url, '_blank');
			} else {
				$state.go('viewLanguage.entry.state', {
					mobileAppId: $scope.mobileAppId,
					languageId: languageId,
					stateName: stateName
				});
			}
		};
	}
])

/**
 * Custom language filter because default filter finds values when it should
 * not like when for example searching for "tr".
 */
.filter('languageFilter', function() {
	return function(languages, filterString) {
		var returnValue = [];

		if (!filterString) {
			return languages;
		}

		var filterStringClean = filterString.replace(/[^\w\s-]/gi, '');
		if (filterStringClean !== filterString) {
			// If they are not identical it means there is some strange
			// symbol in there which would not be in the language name so we
			// can be sure that none would match so return directly empty.
			return returnValue;
		}

		var filterRegex = new RegExp(filterStringClean, 'i');

		languages.forEach(function(language) {
			if (language.ISO.match(filterRegex) || language.name.match(filterRegex)) {
				returnValue.push(language);
			}
		});

		return returnValue;
	};
});
